<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-4'
    ]"
    alt="M1Pay logo"
    src="@/assets/image/logo-m1pay.svg"
  />
</template>